.root {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
